import DebugSrv from '@/components/Debug/DebugSrv';
import { loadRemoteScript } from './helpers';

/** ******** */
/*  STRIPE  */
/** ******** */
function initLoad(stripeConfig, darkMode = false) {
  return loadRemoteScript('https://js.stripe.com/v3/', 'lib-stripe', { removeOnError: true }).then(() => {
    let stripeKey = 'pk_live_WzXkaTeYtwqEh1PUC357fQus';
    if (DebugSrv.local) {
      stripeKey = 'pk_test_ZSvv85IquUi9RIVLObsc4lmw';
    }
    // Initialize Stripe
    const stripeData = {};
    stripeData.stripe = window.Stripe(stripeKey);
    const elements = stripeData.stripe.elements();
    let style = { empty: { '::placeholder': { color: 'rgba(0, 0, 0, 0.5)' } } };
    if (darkMode) style = { base: { color: 'white' }, empty: { '::placeholder': { color: 'rgba(255, 255, 255, 0.5)' } } };

    Object.keys(stripeConfig).forEach((key) => {
      if (key == 'cvc') {
        stripeData[key] = elements.create(stripeConfig[key], { placeholder: '123', style });
      } else if (key == 'cardNumber') {
        stripeData[key] = elements.create(stripeConfig[key], { showIcon: true, disableLink: true, style }); // showIcon shoud show card brand icon but is not working...
      } else {
        stripeData[key] = elements.create(stripeConfig[key], { style });
      }
      stripeData[key].mount(`#${key}`);
    });

    return stripeData;
  });
}

export default {
  initLoad,
};
